// src/components/MsmeImpactCards.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MsmeImpactCards.css';

const MsmeImpactOutlineCard = ({ logoSrc, title, value, bgColor, infoText }) => {
  return (
    <div className="msmeimpact-outline-card" style={{ backgroundColor: bgColor }}>
      <div className="msmeimpact-card-header">
        <img src={logoSrc} alt="Logo" className="msmeimpact-logo" />
        <h3>{title}<span className="info-wrapper">
            <span className="info-icon">i</span>
            <div className="tooltip">{infoText}</div>
          </span></h3>
      </div>
      <div className="msmeimpact-card-content">
        <p><strong>{value}</strong></p>
      </div>
    </div>
  );
};

const formatNumber = (num) => {
  return new Intl.NumberFormat().format(num);
};

const MsmeImpactCards = () => {
  const [msmeImpactValues, setMsmeImpactValues] = useState({
    applications_submitted: '',
    citizen_impacted: '',
    msmes_impacted: '',
    hds_trained: '',
    benefits_unblocked: ''
  });

  const fetchData = async () => {
    try {
      const response = await axios.get('/data.json');
      console.log('Fetched data:', response.data);

      setMsmeImpactValues({
        applications_submitted: formatNumber(response.data.applications_submitted) || 0,
        citizen_impacted: formatNumber(response.data.citizen_impacted) || 0,
        msmes_impacted: formatNumber(response.data.msmes_impacted) || 0,
        hds_trained: formatNumber(response.data.hds_trained) || 0,
        benefits_unblocked: formatNumber(response.data.benefits_unblocked) || 0
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="msmeimpact-card-container">
        <MsmeImpactOutlineCard
          logoSrc="/Citizen_Impacted.jpg"
          title="Citizen Impacted"
          value={msmeImpactValues.citizen_impacted}
          bgColor="var(--citizen-impacted-color)"
          infoText='Total number of citizens whose applications are in the "Benefit Received" (BR) status.'

        />
        <MsmeImpactOutlineCard
          logoSrc="/Application_Submitted.jpg"
          title="Applications Submitted"
          value={msmeImpactValues.applications_submitted}
          bgColor="var(--applications-submitted-color)"
          infoText='Total number of schemes where the application has reached the "Document Submitted" status. (Document Submitted: Status when proof of submission for the application is uploaded to the case).'

        />
        <MsmeImpactOutlineCard
          logoSrc="/MSMEs_Impacted.jpg"
          title="MSMEs Reached"
          value={msmeImpactValues.msmes_impacted}
          bgColor="var(--msmes-impacted-color)"
          infoText='Total number of Micro, Small, and Medium Enterprises (MSMEs) that have been reached or screened.'

        />
        <MsmeImpactOutlineCard
          logoSrc="/HDs_Trained.jpg"
          title="HDs Trained"
          value={msmeImpactValues.hds_trained}
          bgColor="var(--hds-trained-color)"
          infoText="Total number of HD's who have been trained or onboarded."

        />
        <MsmeImpactOutlineCard
          logoSrc="/Benefits_Unblocked.jpg"
          title="Benefits Unlocked"
          value={msmeImpactValues.benefits_unblocked}
          bgColor="var(--benefits-unblocked-color)"
          infoText="The total value of benefits unlocked."

        />
      </div>
    </div>
  );
};

export default MsmeImpactCards;
